import OverlayTips from "../OverlayTips";

function CustomizationPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

CustomizationPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".formfieldtitle").eq(1), {
            messageKey: "tips.customization.show_logo",
            direction: OverlayTips.DIRECTION_BOTTOM_LEFT,
            offsetX: 20,
            offsetY: -50
        });

        this.add($(".inputChooseFile").eq(0), {
            messageKey: "tips.customization.upload_logo",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -120,
            offsetY: 10
        });
    }
});

export default CustomizationPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/CustomizationPageOverlayTipsManager.js